import React from "react";

const Openings = () => {
  return (
    <div className="my-32 px-6 lg:px-16">
      <div>
        <h1 className="head-text mb-2">Job openings</h1>
        <span className="max-w-[660px] text-paragraph text-lg mx-auto text-center">
          Join ZAP's team and revolutionize transportation and logistics with
          us! Explore job openings today.
        </span>
        <div className="mx-auto w-full flex items-center justify-center mt-3">
          <button className="w-[200px]">See openings</button>
        </div>
      </div>
    </div>
  );
};

export default Openings;
